import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const IconWrapper = styled(Box).attrs({
  justify: 'center',
  align: 'center',
  color: 'primaryText',
})``;
